import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function BadgesPage({ user, embedded = false }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState("all");
  const token = localStorage.getItem("kami_token");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data: res } = await axios.get(`${API_BASE}/badges`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!cancelled) setData(res);
      } catch (err) {
        if (!cancelled) {
          setError(err.response?.data?.error || "Could not load badges.");
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (error) {
    return (
      <div className={embedded ? "portal-embed" : "portal-page"}>
        <div className="profile-login-gate">
          {!embedded && <h1>Badges</h1>}
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className={embedded ? "portal-embed" : "portal-page"}>
        <div className="page-loading">
          <div className="sync-spinner" />
        </div>
      </div>
    );
  }

  const categories = Array.isArray(data.categories)
    ? data.categories
    : Object.values(data.categories || {});
  const badges = (data.badges || []).filter((b) => {
    if (filter === "owned") return b.owned;
    if (filter === "all") return true;
    return b.category === filter;
  });

  return (
    <div className={embedded ? "portal-embed" : "portal-page"}>
      <header className="portal-page-head">
        {!embedded && <h1>Badges</h1>}
        <p>
          {user
            ? `You have ${data.ownedCount || 0} unlocked.`
            : "Browse the badge archive. Log in to see yours."}
        </p>
      </header>
      <div className="portal-tabs">
        <button
          type="button"
          className={`portal-tab${filter === "all" ? " active" : ""}`}
          onClick={() => setFilter("all")}
        >
          All
        </button>
        {user && (
          <button
            type="button"
            className={`portal-tab${filter === "owned" ? " active" : ""}`}
            onClick={() => setFilter("owned")}
          >
            Owned
          </button>
        )}
        {categories.map((c) => {
          const key = typeof c === "string" ? c : c.id || c.key || c.name;
          const label = typeof c === "string" ? c : c.label || c.name || key;
          return (
            <button
              key={key}
              type="button"
              className={`portal-tab${filter === key ? " active" : ""}`}
              onClick={() => setFilter(key)}
            >
              {label}
            </button>
          );
        })}
      </div>
      <div className="badge-grid">
        {badges.map((b) => (
          <div
            key={b.name}
            className={`badge-card${b.owned ? " owned" : ""}`}
          >
            <span className="emoji">{b.emoji}</span>
            <strong>{b.name}</strong>
            <p className="portal-muted">{b.desc}</p>
            {b.buff && <p className="badge-buff">{b.buff}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
